var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilledArrowDown = function SvgFilledArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.465h14.755l-7.378 9.837L2 1.465Z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 1.639,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
};
export default SvgFilledArrowDown;